 import { 
  statusAdsInfoStart,
  statusAdsInfoSuccess,
  statusAdsInfoFailure 
} from "./adsInfoSlice";

import { get, post, put, remove } from "../../requestMethods"
import { Dispatch } from "react";

export const getAdsInfosApi = () => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusAdsInfoStart())
    let response = await get(`adsInfo`)
    const resData = response.data.success
    if(resData) {
      dispatch(statusAdsInfoSuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusAdsInfoFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusAdsInfoFailure(errData))
      return [errData]
    }
  }
}

export const AddAdsInfoApi = (data: any) => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusAdsInfoStart())
    let response = await post(`adsInfo`, data);
    const resData = response.data.success
    if(resData) {
      dispatch(statusAdsInfoSuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusAdsInfoFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusAdsInfoFailure(errData))
      return [errData]
    }
  }
}

export const EditAdsInfoApi = (adsInfoId: string, data: any) => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusAdsInfoStart())
    let response = await put(`adsInfo/${adsInfoId}`, data);
    const resData = response.data.success
    if(resData) {
      dispatch(statusAdsInfoSuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusAdsInfoFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusAdsInfoFailure(errData))
      return [errData]
    }
  }
}

export const DeleteAdsInfoApi = (adsInfoId: string) => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusAdsInfoStart())
    let response = await remove(`adsInfo/${adsInfoId}`);
    const resData = response.data.success
    if(resData) {
      dispatch(statusAdsInfoSuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusAdsInfoFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusAdsInfoFailure(errData))
      return [errData]
    }
  }
}

export const AddAdsInfoPhotoApi = (adsinfoId: string = "", adsinfo: any) => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusAdsInfoStart())
    const response = await post(`adsinfo/${adsinfoId}`, adsinfo)
    const dataRes  = await response.data.success
    if(dataRes) {
      dispatch(statusAdsInfoSuccess(dataRes))
      return true;
    }
  } catch (err: any) {
    const errData = err.response.data
    const formErrors = errData.formErrors ? errData.formErrors : [errData];
    if(err.response && err.response.status === 300) {
      dispatch(statusAdsInfoFailure(formErrors))      
      return formErrors
    } else {
      dispatch(statusAdsInfoFailure(errData.err))      
      return [errData.err]
    }
  }
}

export const DeleteAdsInfoPhotoApi = (id: any, img: any = "") => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusAdsInfoStart());
    const response = await remove(`adsinfo/${id}/${img}`);
    const dataRes = response.data.success
    if(dataRes) {
      dispatch(statusAdsInfoSuccess(dataRes))
      return true;
    }
  } catch(err: any) {
    const errData = err.response.data
    const formErrors = errData.formErrors ? errData.formErrors : [errData];
    if(err.response && err.response.status === 300) {
      dispatch(statusAdsInfoFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusAdsInfoFailure(errData.err))
      return errData.err
    }
  }
}

export const clearAdsInfoApi = async (dispatch: Dispatch<any>) => {
  dispatch(statusAdsInfoSuccess([]))
}
